import numeral from "numeral";

// format number to 2 decimal places
export const weightFormatter = (value: any) => numeral(value).format("0,0.00");
